let _this;
export default {
  name: "handle-incident",
  data(){
    return{
      handleEventModal:false,
      incidentList:[],/*显示的事件列表*/
      handleEventInfo:{
        processType:0,
        note:""
      }, /*事件处理参数*/
      noteFlag:false, /*文本验证*/
    }
  },
  mounted(){
    _this = this;
    eventBus.$on('handleIncident',(array)=>{
      _this.handleEventInfo = {
        processType:0,
        note:""
      };
      _this.noteFlag = false;
      _this.incidentList = array;
      _this.handleEventModal = true;
    })
  },
  beforeDestroy(){
    eventBus.$off('handleIncident');
  },
  methods:{
    // 删除
    deleteItem:function(item, index){
      _this.incidentList.splice(index, 1);
    },
    //发送事件处理
    submitHandleIncident:function(){
      if(_this.handleEventInfo.processType !== 2){
        _this.noteFlag = false;
        if(_this.handleEventInfo.processType === 0 && _this.handleEventInfo.note === ""){
          _this.noteFlag = true;
          return;
        }
        let paramsList = [];
		let msgIds = [];
        _this.incidentList.forEach(event =>{
		  msgIds.push(event.id);
          paramsList.push({
            id: event.id,
            processType: _this.handleEventInfo.processType,
            note: _this.handleEventInfo.note
          });
        });
        this.$ajax.post('IncidentRecord/Process', paramsList).then(function (res) {
          if(res.data.success){
            _this.messageNotice('success');
            _this.handleEventModal = false;
            eventBus.$emit('updateMsgList');
            eventBus.$emit('closeMsgModal');
			
			/* 关闭需要处理处理过的消息的音频 */
			eventBus.$emit('closeMsgAudio', msgIds );
			/* 关闭需要处理处理过的消息的音频 end */
			
          }else{
            _this.messageNotice('error',res.data.message);
          }
        })
      }else{
        _this.handleEventModal = false;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/handleIncident.js